import {action, computed, observable, runInAction} from "mobx";
import {IDestinationCategory} from "../../types/IDestinationCategory";
import Api from "../../services/api";
import {DestinationTypes} from "../../types/DestinationTypes";

class DestCategoriesStore {
    @observable public destinations:IDestinationCategory[] = [];

    @action
    public getDestinationsByBuildingId = async (buildingId:string|number|undefined) => {
        if(!buildingId){
            this.destinations = [];
            return;
        }

        try{
            const destinations = await Api.getDestinationCategoriesByBuildingId(buildingId.toString());
            runInAction(() => {
                this.destinations = destinations;
            });
        }catch(e){
            console.log(e);
        }
    }

    @computed
    public get parkingDestinations(){
        return this.destinations.filter(d => d.destinationTypeId === DestinationTypes.Parking);
    }
}

const destCategoriesStore = new DestCategoriesStore();
export default destCategoriesStore;
